import { piOhDeepMerge } from "@/utils/object.helper";
/**
 * 饼图 -  configData 配置对象   div
 *
 
 }
 */
export const getBarData = (configData, optionData) => {
    const title = getTitle(configData, optionData);
    const grid = getGrid(configData, optionData);
    const legend = getLegend(configData, optionData);
    const xAxis = getXAxis(configData, optionData);
    const series = getSeries(configData, optionData);
    const yAxis = getYAxis(configData, optionData, series);
    const option = {
        title: title,
        legend: legend,
        tooltip: {
            trigger: "axis",
        },
        xAxis: xAxis,
        yAxis: yAxis,
        grid: grid,
        color: optionData.color || [],
        series: series,
    };
    return option;
};
const getYAxis = (configData, optionData, series) => {
    let yAxis = {
        type: "value",
        axisLine: {
            show: false,
        },
        axisLabel: {
            color: "#A4A8AC",
        },
        axisTick: {
            show: false,
            alignWithLabel: true,
            inside: true,
            length: 0,
        },
        splitLine: {
            show: false,
        },
    };
    if (series && series.length == 1 && series[0].data.length > 0) {
        const max = Math.max.apply(null, series[0].data);
        yAxis.interval = Math.ceil(max / 3); // 平均分为3份
    }
    if (optionData.yAxis) {
        yAxis = piOhDeepMerge(yAxis, optionData.yAxis);
    }
    return yAxis;
};
/**
 * 获取标题对象, 主要是标题的位置 和 是否有副标题 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getTitle = (configData, optionData) => {
    let title = {
        text: "",
        // zlevel: 0,
        top: "-5",
        left: "0%",
        textStyle: {
            color: "#101A25",
            fontSize: 14,
            lineHeight: 22,
            fontWeight: "600",
        },
    };
    if (optionData.title) {
        title = piOhDeepMerge(title, optionData.title);
    }
    return title;
};
/**
 * 获取 Legend, 主要是位置 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getLegend = (configData, optionData) => {
    const nameWidth = 72; // 名称长度
    let legend = {
        show: false,
        orient: "vertical",
        left: 0,
        top: "center",
        itemWidth: 6,
        itemHeight: 6,
        itemGap: 6,
        icon: "circle",
        formatter: ["{a|{name}}"].join("\n"),
        textStyle: {
            color: "#666",
            fontSize: 12,
            lineHeight: 20,
            rich: {
                //这里定义a的样式
                a: {
                    width: nameWidth,
                },
            },
        },
    };
    if (optionData.legend) {
        legend = piOhDeepMerge(legend, optionData.legend);
    }
    return legend;
};
const getXAxis = (configData, optionData) => {
    let xAxis = {
        type: "category",
        data: [],
        axisLine: {
            show: false,
        },
        axisTick: {
            show: false,
        },
        axisLabel: {
            color: "#A4A8AC",
        },
    };
    if (optionData.data && optionData.data.length > 0) {
        let dataArr = []; // x轴名称数组
        if (optionData.data) {
            dataArr = optionData.data.map((item) => {
                return item.name;
            });
        }
        xAxis.data = dataArr;
    }
    if (optionData.xAxis) {
        xAxis = piOhDeepMerge(xAxis, optionData.xAxis);
    }
    return xAxis;
};
/**
 * 获取 Series 主要是 center 位置 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getSeries = (configData, optionData) => {
    [
        {
            data: [],
            type: "bar",
            barWidth: 8,
        },
    ];
    // 单个
    if (optionData.data && optionData.data.length > 0) {
        let valueArr = [];
        if (optionData.data) {
            valueArr = optionData.data.map((item) => {
                return item.value;
            });
        }
        return [
            {
                data: valueArr,
                type: "bar",
                barWidth: 8,
            },
        ];
    }
    else if (optionData.series) {
        const series = [];
        optionData.series.map((item) => {
            if (!item.type) {
                item.type = "bar";
            }
            if (!item.barWidth) {
                item.barWidth = 8;
            }
            series.push(item);
        });
        return series;
    }
};
const getGrid = (configData, optionData) => {
    let grid = {
        top: "32",
        left: "35",
        right: "4%",
        bottom: "20",
    };
    if (optionData.grid) {
        grid = piOhDeepMerge(grid, optionData.grid);
    }
    return grid;
};
